<template>
  <div>wat</div>
</template>

<script>
  export default {
    name: 'Callback'
  }
</script>



// WEBPACK FOOTER //
// index.vue?00b87378